import { setCurrentMeeting } from "stores/meeting";
import { putUpdateObjectApi } from "api/general";
import { MEETINGS } from "./constants/customConstant";


export const getUnitsFromPageType = (state, pageType) => {
    const { allAuthorizedUnits, allReadAuthorizedUnits } = state.authStore;

    let list = [];

    if (pageType === "1" || pageType === "3") {
        list = allAuthorizedUnits;
    } else if (pageType === "2" || pageType === "4") {
        list = allReadAuthorizedUnits;
    }

    if (pageType === "1" || pageType === "2") {
        list = list.filter(unit => unit.inst === "YK");
    } else if (pageType === "3" || pageType === "4") {
        list = list.filter(unit => unit.inst !== "YK");
    }

    return list;
}


export const updateMeetingAfterUserOperation = async (currentMeeting, authUser, dispatch) => {
    try {
        const { user, users, decisionCount, isThereReminder, archiveFileId, archiveFileName, ...meetingObj } = currentMeeting;
        meetingObj.adminUserId = authUser.id;
        const result = await putUpdateObjectApi(MEETINGS, meetingObj);
        if (result.status) {
            const updatedMeetingWithUserData = {
                ...meetingObj,
                user: authUser,
                users,
                decisionCount,
                isThereReminder,
                archiveFileId,
                archiveFileName
            };

            dispatch(setCurrentMeeting(updatedMeetingWithUserData));

            return true;
        }
    } catch (error) {
        console.error('Meeting güncelleme hatası:', error);
        return false;
    }
};
